import React, { useState } from 'react';
import './App.css';
import logo from './assets/netusoft.png';
import { ReactComponent as InventIcon } from './assets/invent.svg';
import { ReactComponent as BuildIcon } from './assets/build.svg';
import { ReactComponent as DeliverIcon } from './assets/deliver.svg';

function App() {
  const [activePanel, setActivePanel] = useState('services');

  return (
    <div className="frame-wrapper">
      <div className="frame">
          <header className="frame-header">
            <div className="frame-logo">
              <img src={logo} className="frame-logo-img" alt="Netusoft" draggable={false} />
              <span className="frame-brand">NETUSOFT</span>
            </div>
            <nav className="frame-nav">
              <button
                className={`frame-nav-btn ${activePanel === 'services' ? 'active' : ''}`}
                onClick={() => setActivePanel('services')}
              >
                SERVICES
              </button>
              <button
                className={`frame-nav-btn ${activePanel === 'values' ? 'active' : ''}`}
                onClick={() => setActivePanel('values')}
              >
                VALUES
              </button>
              <button
                className={`frame-nav-btn ${activePanel === 'about' ? 'active' : ''}`}
                onClick={() => setActivePanel('about')}
              >
                ABOUT
              </button>
              <button
                className={`frame-nav-btn ${activePanel === 'contact' ? 'active' : ''}`}
                onClick={() => setActivePanel('contact')}
              >
                CONTACT
              </button>
            </nav>
          </header>

          <main className="frame-main">
            <div className="frame-hero">
              <h1>SOFTWARE THAT<br />ACTUALLY SHIPS</h1>
            </div>

            <div className="frame-grid">
              <div
                id="services"
                role="button"
                tabIndex={0}
                className={`frame-cell ${activePanel === 'services' ? 'expanded' : ''}`}
                onClick={() => setActivePanel('services')}
                onKeyDown={(e) => e.key === 'Enter' && setActivePanel('services')}
              >
                <div className="cell-label">SERVICES</div>
                <div className="cell-content">
                  <div className="cell-item"><strong>WEB</strong> — Concept to launch. Fast. Scalable.</div>
                  <div className="cell-item"><strong>MOBILE</strong> — Native or cross-platform. Your vision, every screen.</div>
                  <div className="cell-item"><strong>CLOUD</strong> — Infrastructure that scales when you do.</div>
                </div>
              </div>

              <div
                id="values"
                role="button"
                tabIndex={0}
                className={`frame-cell ${activePanel === 'values' ? 'expanded' : ''}`}
                onClick={() => setActivePanel('values')}
                onKeyDown={(e) => e.key === 'Enter' && setActivePanel('values')}
              >
                <div className="cell-label">VALUES</div>
                <div className="cell-content">
                  <div className="cell-item"><InventIcon className="cell-icon" /> INVENT — Ask the right questions first.</div>
                  <div className="cell-item"><BuildIcon className="cell-icon" /> BUILD — Code that earns its keep.</div>
                  <div className="cell-item"><DeliverIcon className="cell-icon" /> DELIVER — Shipped. Not promised.</div>
                </div>
              </div>

              <div
                id="about"
                role="button"
                tabIndex={0}
                className={`frame-cell ${activePanel === 'about' ? 'expanded' : ''}`}
                onClick={() => setActivePanel('about')}
                onKeyDown={(e) => e.key === 'Enter' && setActivePanel('about')}
              >
                <div className="cell-label">ABOUT</div>
                <div className="cell-content">
                  Launched 2024. A small team that ships. Developers who code, designers who think, strategists who cut through the noise. No fluff. Just results.
                </div>
              </div>

              <div
                id="contact"
                role="button"
                tabIndex={0}
                className={`frame-cell ${activePanel === 'contact' ? 'expanded' : ''}`}
                onClick={() => setActivePanel('contact')}
                onKeyDown={(e) => e.key === 'Enter' && setActivePanel('contact')}
              >
                <div className="cell-label">CONTACT</div>
                <div className="cell-content">
                  <a href="mailto:hello@netusoft.com">hello@netusoft.com</a><br />
                  +1 (555) 123-4567<br />
                  San Francisco, CA
                </div>
              </div>
            </div>
          </main>

          <footer className="frame-footer">
            <span>© 2024 NETUSOFT</span>
            <span className="frame-motto">INVENT · BUILD · DELIVER</span>
          </footer>
      </div>
    </div>
  );
}

export default App;
